import {VehicleFormDefaultValues, VehicleFormProps, VehicleFormRawValues, VehicleFormType} from "./VehicleForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {getObjectId} from "@ots-frontend/ots-data";
import { useAuth } from "../../../providers/AuthProvider/AuthProvider";

const getInitialValues = (defaultValues: VehicleFormDefaultValues | undefined): VehicleFormRawValues => {
  return {
    name: defaultValues?.name,
    barcode: defaultValues?.barcode,
    vin: defaultValues?.vin,
    company: getObjectId(defaultValues?.company),
    doNotUse: defaultValues?.doNotUse,
  }
}

export type UseVehicleFormProps = Pick<VehicleFormProps, 'defaultValues'> & {}

export function useVehicleForm(props: UseVehicleFormProps): VehicleFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])
  const { companyId } = useAuth()

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
      company: defaultValues?.company ?? companyId,
    }),
    validate: {
      name: (value) => value ? undefined : t("common.validation.required", "Required"),
      company: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
